import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Save } from 'lucide-react';
import PageHeader from '../common/PageHeader';
import PageBreadcrumb from '../common/PageBreadcrumb';
import { useToast } from '../common/Toast';
import complianceService from '../../services/complianceService';

const AddRequirement = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { success, error: showError } = useToast();
  const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    code: '',
    description: '',
    riskLevel: 'Medium'
  });

  const handleSave = async (e) => {
    e.preventDefault();
    if (!formData.code || !formData.description) {
      return showError("Code and Description are required");
    }

    setLoading(true);
    try {
      await complianceService.addRequirement(id, formData);
      success('Requirement added successfully');
      // Redirect back to the Edit Framework form to see the list again
      navigate(`/contracts/frameworks/edit/${id}`);
    } catch (err) {
      showError(err.message || 'Failed to add requirement');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageBreadcrumb />
      <PageHeader 
        title="Add Requirement" 
        description="Add a specific control or requirement to this framework."
      />

      <div className="p-6 max-w-2xl mx-auto">
        <div className="bg-white border rounded-lg shadow-sm p-6">
          <form onSubmit={handleSave}>
            <div className="mb-4">
              <label className="form-label">Requirement Code *</label>
              <input 
                type="text" 
                className="form-control" 
                placeholder="e.g. Art-17 or ISO-9.2"
                value={formData.code}
                onChange={e => setFormData({...formData, code: e.target.value})}
              />
            </div>

            <div className="mb-4">
              <label className="form-label">Description *</label>
              <textarea 
                className="form-control" 
                rows="3"
                placeholder="Describe the control..."
                value={formData.description}
                onChange={e => setFormData({...formData, description: e.target.value})}
              />
            </div>

            <div className="mb-6">
              <label className="form-label">Risk Level</label>
              <select 
                className="form-select"
                value={formData.riskLevel}
                onChange={e => setFormData({...formData, riskLevel: e.target.value})}
              >
                <option>Low</option>
                <option>Medium</option>
                <option>High</option>
                <option>Critical</option>
              </select>
            </div>

            <div className="flex justify-end gap-3">
              {/* Cancel button also redirects back to the Edit form */}
              <button 
                type="button" 
                className="btn btn-outline-secondary"
                onClick={() => navigate(`/contracts/frameworks/edit/${id}`)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                <Save size={18} className="me-2" />
                {loading ? 'Saving...' : 'Add Requirement'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddRequirement;